export default __webpack_public_path__ + "static/media/logo_AjT_ALT_marro.2192504e.png";